export const driverAttendanceEditorPath = 'driver-attendance-editor';
